export const SET_WAITING = 'SET_WAITING';
export const SET_RESULT = 'SET_RESULT';
export const SET_PAGE_INDEX = 'SET_PAGE_INDEX';
